import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PlatformStats {
  users: number;
  tasks: number;
  work_logs: number;
  applications: number;
  meetings: number;
  skills: number;
  diary_entries: number;
  modules: number;
  timestamp: string;
}

interface HealthStatus {
  status: 'healthy' | 'degraded' | 'unhealthy';
  timestamp: string;
  uptime_check: boolean;
  latency: {
    total_ms: number;
    database_ms: number;
    auth_ms: number;
    storage_ms: number;
  };
  services: {
    database: { status: string; latency_ms: number };
    auth: { status: string; latency_ms: number };
    storage: { status: string; latency_ms: number };
  };
  version: string;
}

export function usePlatformStats() {
  return useQuery<PlatformStats>({
    queryKey: ['platform-stats'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('platform-stats');
      if (error) throw error;
      return data as PlatformStats;
    },
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    placeholderData: { users: 0, tasks: 0, work_logs: 0, applications: 0, meetings: 0, skills: 0, diary_entries: 0, modules: 7, timestamp: '' },
  });
}

export function useHealthCheck() {
  return useQuery<HealthStatus>({
    queryKey: ['health-check'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('health-check');
      if (error) throw error;
      return data as HealthStatus;
    },
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}
